import { cn } from "@/lib/utils";

export function DifficultyIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[15px] w-[13px] text-rose-red", className)}
      viewBox="0 0 13 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.373 4.954v2.744l2.504 1.446V6.25L.382 4.81a1.12 1.12 0 00-.01.143zm3.324 4.663l2.507 1.448V8.17L3.697 6.724v2.893zm2.917-5.05L4.108 6.014 6.614 7.46l2.507-1.447-2.507-1.447zm.41 6.498l2.507-1.448V6.724L7.024 8.171v2.894zm5.822-6.255l-2.494 1.44v2.894l2.504-1.446V4.954a.986.986 0 00-.01-.144zm-.53-.791L9.941 2.647 7.435 4.094 9.94 5.54l2.496-1.44a1.072 1.072 0 00-.12-.081zM9.121 2.173L7.155 1.038a1.081 1.081 0 00-1.08 0L4.107 2.173 6.615 3.62 9.12 2.173zm-5.833.474L.912 4.018a1.072 1.072 0 00-.12.082l2.495 1.44 2.507-1.446-2.506-1.447zM.373 10.915c0 .385.206.743.54.935l1.964 1.135V10.09L.373 8.645v2.27zm3.324 2.543l2.378 1.373c.042.024.085.045.13.063v-2.882l-2.508-1.447v2.893zm3.327 1.436c.045-.018.088-.04.13-.063l2.377-1.372v-2.894l-2.507 1.447v2.882zm3.328-1.909l1.964-1.135c.333-.192.54-.55.54-.935v-2.27l-2.504 1.446v2.894z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MinutesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[15px] w-[13px] text-rose-red", className)}
      viewBox="0 0 13 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M5.04.894h2.666c.367 0 .667.3.667.667 0 .367-.3.667-.667.667H5.039a.669.669 0 01-.666-.667c0-.367.3-.667.666-.667zm2 8c0 .367-.3.667-.667.667a.669.669 0 01-.667-.667V6.228c0-.367.3-.667.667-.667.366 0 .666.3.666.667v2.666zm4.02-3.74l.5-.5a.662.662 0 000-.933l-.007-.007a.662.662 0 00-.934 0l-.5.5a5.974 5.974 0 00-3.746-1.32c-3.2 0-5.92 2.64-6 5.84a5.999 5.999 0 006 6.16 5.996 5.996 0 004.686-9.74zm-9.354 3.74a4.663 4.663 0 004.667 4.667 4.663 4.663 0 004.666-4.667 4.663 4.663 0 00-4.666-4.666 4.663 4.663 0 00-4.667 4.666z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function PlayersIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[13px] w-[22px] text-rose-red", className)}
      viewBox="0 0 22 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M10.235 3.466c0 1.422-1.234 2.571-2.773 2.571-1.54 0-2.782-1.149-2.782-2.571C4.68 2.043 5.923.894 7.462.894c1.54 0 2.773 1.149 2.773 2.572zm7.418 0c0 1.422-1.234 2.571-2.773 2.571-1.54 0-2.782-1.149-2.782-2.571 0-1.423 1.243-2.572 2.782-2.572 1.54 0 2.772 1.149 2.772 2.572zM7.463 7.75c-2.161 0-6.492 1.003-6.492 3v1.286c0 .471.417.857.927.857h11.128c.51 0 .927-.386.927-.857V10.75c0-1.997-4.33-3-6.49-3zm6.517.043c.325-.026.63-.043.9-.043 2.16 0 6.49 1.003 6.49 3v1.286c0 .471-.417.857-.927.857H15.64c.102-.265.167-.557.167-.857V10.75c0-1.26-.733-2.211-1.79-2.923l-.009-.01c-.007-.008-.015-.018-.028-.024z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function VirtualIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[13px] w-[17px] text-rose-red", className)}
      viewBox="0 0 17 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.876 12.166l-1.795-2.31V1.35a.465.465 0 00-.473-.456H2.363a.465.465 0 00-.473.456v8.507L.095 12.166a.441.441 0 00-.045.477c.08.154.244.251.423.251h16.026a.475.475 0 00.423-.251.441.441 0 00-.046-.477zm-10.733-.183l.354-.76h3.978l.353.76H6.143zm7.993-2.43h-11.3V1.805h11.3v7.746z"
        fill="currentColor"
      />
    </svg>
  );
}
